import React,{useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import {Helmet} from 'react-helmet';
import {CheckCircleIcon,ClockIcon,ArrowRightIcon} from '@heroicons/react/outline';
import {sprintf} from 'sprintf-js';
import globalSettingsManagerUtil from '../../utils/global-settings-manager-util';
import isOrganicUtil from '../../utils/is-organic-util';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const PaymentSuccess=({globalSettings})=>{
  const navigate=useNavigate();
  const isProcessingComplete=globalSettings.user?.next_level===parseInt(localStorage.getItem('intendedNextLevel'));
  useEffect(()=>{
    if(isProcessingComplete){
      return;
    }
    const timeout=setTimeout(()=>{
      globalSettingsManagerUtil.infer(true);
    },1000);
    return ()=>clearTimeout(timeout);
  },[globalSettings.user]);
  useEffect(()=>{
    if(!globalSettings.token&&isOrganicUtil()){
      navigate(`/${globalSettings.lang}/`);
    }
  },[globalSettings.token,navigate]);
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {(isProcessingComplete?locales.paymentSuccessTitle:locales.paymentProcessingTitle)[globalSettings.lang]}</title>
      </Helmet>
      <Navbar
        globalSettings={globalSettings}
      />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='w-full px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='max-w-2xl mx-auto text-center'>
            {!isProcessingComplete?(
              <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
                <div className='h-16 w-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6'>
                  <ClockIcon className='h-8 w-8 text-purple-800 animate-spin' />
                </div>
                <h1 className='text-3xl font-bold text-gray-900 mb-4'>
                  {locales.paymentProcessingHeading[globalSettings.lang]}
                </h1>
                <p className='text-lg text-gray-600 mb-6'>
                  {locales.paymentProcessingDescription[globalSettings.lang]}
                </p>
                <p className='text-gray-500'>
                  {sprintf(
                    locales.paymentProcessingContact[globalSettings.lang],
                    'support@nekotranslate.ai',
                  )}
                </p>
              </div>
            ):(
              <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
                <div className='h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6'>
                  <CheckCircleIcon className='h-8 w-8 text-green-600' />
                </div>
                <h1 className='text-3xl font-bold text-gray-900 mb-4'>
                  {locales.paymentSuccessHeading[globalSettings.lang]}
                </h1>
                <p className='text-lg text-gray-600 mb-8'>
                  {locales.paymentSuccessDescription[globalSettings.lang]}
                </p>
                <Link to={`/${globalSettings.lang}/translator`} className='inline-block'>
                  <button className='bg-purple-800 hover:bg-purple-600 text-white px-8 py-3 rounded-lg text-lg font-medium flex items-center justify-center mx-auto'>
                    {locales.paymentSuccessButton[globalSettings.lang]}
                    <ArrowRightIcon className='ml-2 h-5 w-5' />
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default PaymentSuccess;

